import { render } from "./IconMenu.vue.js?vue&type=template&id=7002be2a!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconMenu.vue?vue&type=template&id=7002be2a"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__